import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import configServ from "../../../services/config";


export default function RegisteredPaymentsTable() {
  const { company_id } = useSelector((state) => state.GlobalVariables);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ✅ API Call
  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await configServ.getRegisteredPaymentsDonation({
        company_id,
      });

      if (res.status === 200 && res.data) {
        setRows(res.data);
      } else {
        setRows([]);
      }
    } catch (error) {
      console.error("Error fetching payments:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (company_id) {
      fetchData();
    }
  }, [company_id]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // ✅ Header Styles (blue background)
  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#1976d2",
    color: "white",
  };

  const cellStyle = {
    fontSize: 13,
    padding: "8px",
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: "70vh" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellStyle}>Sl. No.</TableCell>
              <TableCell sx={headerCellStyle}>Ledger Name</TableCell>
              <TableCell sx={headerCellStyle}>Email</TableCell>
              <TableCell sx={headerCellStyle}>Amount</TableCell>
              <TableCell sx={headerCellStyle}>Mobile</TableCell>
              <TableCell sx={headerCellStyle}>Tran No</TableCell>
              <TableCell sx={headerCellStyle}>Date</TableCell>
              <TableCell sx={headerCellStyle}>Account Name</TableCell>
              <TableCell sx={headerCellStyle}>Branch Address</TableCell>
              <TableCell sx={headerCellStyle}>IFSC Code</TableCell>
              <TableCell sx={headerCellStyle}>Account Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Box sx={{ py: 2 }}>
                    <CircularProgress size={28} />
                  </Box>
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Typography sx={{ color: "red" }}>
                    No record found.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell sx={cellStyle}>
                      {index + 1 + page * rowsPerPage}
                    </TableCell>
                    <TableCell sx={cellStyle}>{row.ledger_name}</TableCell>
                    <TableCell sx={cellStyle}>{row.email}</TableCell>
                    <TableCell sx={cellStyle}>₹{row.amount}</TableCell>
                    <TableCell sx={cellStyle}>{row.mobile_no}</TableCell>
                    <TableCell sx={cellStyle}>{row.tran_number}</TableCell>
                    <TableCell sx={cellStyle}>{row.date}</TableCell>
                    <TableCell sx={cellStyle}>{row.accountname}</TableCell>
                    <TableCell sx={cellStyle}>{row.branchAddress}</TableCell>
                    <TableCell sx={cellStyle}>{row.ifsc_code}</TableCell>
                    <TableCell sx={cellStyle}>{row.accountNumber}</TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
